import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Modal from "react-modal";

const AgriPromoterTargetForm = (props) => {
  const frmRef = useRef({});
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeId, setEmployeeId] = useState(0);

  const [employeeTargetData, setEmployeeTargetData] = useState([]);

  const [filteredEmployees, setFilteredEmployees] = useState("");

  const [isIndividual, setIsIndividual] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const [noOfDemo, setNoOfDemo] = useState(0);

  const [selectedEmployeeIndex, setSelectedEmployeeIndex] = useState(null);
  const [modalMode, setModalMode] = useState("global"); // or "individual"
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  const { sendRequest: getEmp } = useHttp();
  const { sendRequest: getProducts } = useHttp();
  const [productDetails, setProductDetails] = useState([]);

  const loadData = () => {
    getEmp(
      {
        url: `/api/employeeListForTargetAllocation/?useCase=Agri Promoter&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        // console.log("emp11", data);
        setEmployeeData(data?.employeeList);
        setFilteredEmployees(data?.employeeList);
      }
    );
  };

  useEffect(() => {
    loadData();
  }, [getEmp]);

  const getProductDetails = () => {
    getProducts(
      {
        url: `/api/FillAfsProductListForAgriPromoter/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setProductDetails(data);
      }
    );
  };
  useEffect(() => {
    getProductDetails();
  }, [getProducts]);

  const handleEmployeeChange = (event) => {
    const Id = event.target.value;

    const filteredEmployee = employeeData?.filter((item) => item.empId == Id);

    setFilteredEmployees(filteredEmployee);

    setEmployeeId(event.target.value);
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 50,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "4%",
      left: "30%",
      borderRadius: "5px",
      maxWidth: "650px",
      maxHeight: "700px",

      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange",e.target.value)
    setSelectedFromDate(e.target.value);
    setSelectedToDate("");
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 90);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(currentDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate",toDate)

  const [selectedToDate, setSelectedToDate] = useState();

  const handleApplyAllClick = () => {
    if (
      isIndividual &&
      (!filteredEmployees || filteredEmployees.length === 0)
    ) {
      toast.error("Please select at least one employee.");
      return;
    }

    if (!selectedFromDate) {
      toast.error("From Date is required.");
      return;
    }

    if (!selectedToDate) {
      toast.error("To Date is required.");
      return;
    }

    if (noOfDemo === undefined || noOfDemo === null || noOfDemo === 0) {
      toast.error("No of Demo to be Established is required");
      return;
    }
    if (noOfDemo < 0) {
      toast.error("Enter valid  number for No of Demo to be Established");
      return;
    }



    // if (!productDetails || productDetails?.length === 0) {
    //   toast.error("Please add at least one product detail.");
    //   return;
    // }
    
    // const hasAtLeastOneValidTarget = productDetails.some(
    //   (product) => Number(product.target) >= 1
    // );
    
    // if (!hasAtLeastOneValidTarget) {
    //   toast.error("Target is required and must be at least 1 for at least one product.");
    //   return;
    // }

    const hasNegativeTarget = productDetails?.some(
      (product) => Number(product.target) < 0
    );
    if (hasNegativeTarget) {
      toast.error("Target cannot be less than 0 for any product.");
      return;
    }
    const orgId = localStorage.getItem("orgId");
    const createdBy = parseInt(localStorage.getItem("id"));
    const createdDate = moment().format("DD/MM/YYYY");

    //console.log("filteredEmployees", filteredEmployees);

    const jsonData = filteredEmployees?.map((emp) => ({
      employeeId: emp.empId,
      employeeName: emp.employeeName,
      fromDate: moment(selectedFromDate).format("DD/MM/YYYY"),
      toDate: moment(selectedToDate).format("DD/MM/YYYY"),
      noOfDemoTobeEstablished: noOfDemo || 0,
      orgId: parseInt(orgId, 10),
      status: 1,
      createdDate,
      createdBy,
      productDetail: productDetails.map((product) => ({
        productId: product.productId,
        targetQty: product.target || 0,
        unitId: product.unitId,
        productTypeName: product.productTypeName,
        productSubType: product.productSubType,
        productName: product.productName,
        unitName: product.unitName,
      })),
    }));

    console.log("Generated JSON:", jsonData);

    setFilteredEmployees(
      jsonData.map((emp) => ({
        ...emp,
        empId: emp.employeeId,
        employeeId: emp.employeeId,
      }))
    );
  };

  const { sendRequest: postTargetSet } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const cleanedEmployees = filteredEmployees.map((emp) => ({
      ...emp,
      productDetail: emp.productDetail?.filter(
        (product) => Number(product.targetQty) > 0
      ),
    }));
    console.log(cleanedEmployees);

    const hasMissingDemo = cleanedEmployees?.some(
      (emp) => !emp.noOfDemoTobeEstablished || emp.noOfDemoTobeEstablished <= 0
    );

    if (hasMissingDemo) {
      toast.error("Please enter a valid number of demos for each employee.");
      return;
    }

    const invalidProductDetail = cleanedEmployees?.some(
      (emp) => !emp.productDetail || emp.productDetail.length === 0
    );

    // if (invalidProductDetail) {
    //   toast.error("Product details are required for each employee.");
    //   return;
    // }

    postTargetSet(
      {
        url: "/api/agripromotertarget/",
        method: props.update ? "PUT" : "POST",
        body: cleanedEmployees,
      },
      (data) => {
        toast.success(
          `AgriPromoter Target Details  ${
            props.update ? "Updated" : "Added"
          } Successfully`
        );
        props.addForm(false);
      }
    );
  };

  const isEmployeeDataValid = () => {
    if (!filteredEmployees || filteredEmployees.length === 0) return false;

    return filteredEmployees.every((emp) => {
      const demoValid =
        emp.noOfDemoTobeEstablished !== "" &&
        emp.noOfDemoTobeEstablished !== null &&
        Number(emp.noOfDemoTobeEstablished) >= 0;

      const allProductsValid =
        emp.productDetail &&
        emp.productDetail.length > 0 &&
        emp.productDetail.every(
          (prod) =>
            prod.targetQty !== "" &&
            prod.targetQty !== null &&
            Number(prod.targetQty) >= 0
        );

      return demoValid && allProductsValid;
    });
  };

  const handleDemoChange = (empId, newValue) => {
    const updatedEmployees = filteredEmployees.map((emp) =>
      emp.empId === empId ? { ...emp, noOfDemoTobeEstablished: newValue } : emp
    );

    setFilteredEmployees(updatedEmployees);
  };

  return (
    <>
      {isOpen && (
        <Modal isOpen={true} style={modalStyles}>
          <form
          //   onSubmit={submitAttendanceDetails}
          >
            <div className="">
              <h3 className="card-title">ProductWise Target Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setIsOpen(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>

            <div>
              <div className="row">
                <table className="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th>Product Item Type</th>
                      <th>Product Item SubType</th>
                      <th>Product Name</th>

                      <th>Target</th>
                      <th>Unit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(modalMode === "global"
                      ? productDetails
                      : filteredEmployees[selectedEmployeeIndex]
                          ?.productDetail || []
                    ).map((itm, i) => (
                      <tr key={i}>
                        <td>{itm.productTypeName}</td>
                        <td>{itm.productSubType}</td>
                        <td>{itm.productName}</td>
                        <td>
                          <input
                            type="number"
                            id="target"
                            required
                            className="form-control"
                            defaultValue={0}
                            min={0}
                            value={
                              modalMode === "global"
                                ? itm.target || "0"
                                : itm.targetQty || "0"
                            }
                            onChange={(e) => {
                              const value = e.target.value;

                              if (modalMode === "global") {
                                setProductDetails((prevDetails) =>
                                  prevDetails.map((prod, index) =>
                                    index === i
                                      ? { ...prod, target: value }
                                      : prod
                                  )
                                );
                              } else if (modalMode === "individual") {
                                setFilteredEmployees((prevEmployees) =>
                                  prevEmployees.map((emp, empIdx) => {
                                    if (empIdx !== selectedEmployeeIndex)
                                      return emp;

                                    const updatedProductDetail =
                                      emp.productDetail.map((prod, prodIdx) =>
                                        prodIdx === i
                                          ? { ...prod, targetQty: value }
                                          : prod
                                      );

                                    return {
                                      ...emp,
                                      productDetail: updatedProductDetail,
                                    };
                                  })
                                );
                              }
                            }}
                          />
                        </td>
                        <td>{itm.unitName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="text-center">
                <button
                  type="button"
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    setIsOpen(false);
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </form>
          <br />
          <div></div>
        </Modal>
      )}
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title"> Field Demonstration Target Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Team</label> &nbsp;
                        <input
                          type={"checkbox"}
                          id={"team"}
                          ref={(el) => (frmRef.current["team"] = el)}
                          className="checkbox"
                          checked={!isIndividual}
                          disabled={props.update}
                          onChange={(event) => {
                            //frmRef.current.individual.checked=false;
                            setIsIndividual(false);
                            setFilteredEmployees([]);
                            setEmployeeId(0)
                            loadData();
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Individual</label> &nbsp;
                        <input
                          type={"checkbox"}
                          id={"individual"}
                          ref={(el) => (frmRef.current["individual"] = el)}
                          className="checkbox"
                          disabled={props.update}
                          checked={isIndividual}
                          onChange={(event) => {
                            frmRef.current.team.checked = false;
                            setIsIndividual(event.target.checked);
                            setFilteredEmployees([]);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {isIndividual && (
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Employee Name</label>

                          <select
                            id="emp_name"
                            className="form-control"
                            onChange={handleEmployeeChange}
                            value={employeeId}
                          >
                            <option value="">Select</option>
                            {employeeData &&
                              employeeData.map((x) => (
                                <option key={x.empId} value={x.empId}>
                                  {x.employeeName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    )}
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>From Date</label>

                        <input
                          type={"date"}
                          id={"from_date"}
                          required
                          // max={currentDate}
                          value={selectedFromDate}
                          onChange={handleFDateChange}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>To Date</label>
                        <input
                          type={"date"}
                          id={"to_date"}
                          required
                          className="form-control"
                          min={selectedFromDate}
                          value={selectedToDate}
                          onChange={handleTDateChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>No of Demo to be Established</label>
                        <input
                          type={"number"}
                          id={"noOfDemo"}
                          required
                          value={noOfDemo}
                          min={0}
                          onChange={(e) => {
                            setNoOfDemo(e.target.value);
                          }}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group mt-4 mx-3">
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => {
                            setModalMode("global");
                            setIsOpen(true);
                          }}
                        >
                          Product Details
                        </button>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group mt-4 mx-3">
                        <button
                          type="button"
                          className="btn  btn-info mx-2"
                          onClick={handleApplyAllClick}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                  {filteredEmployees.length > 0 && (
                    <>
                      {isEmployeeDataValid() && (
                        <>
                          <div className="row">
                            <table className="table table-bordered text-center">
                              <thead>
                                <tr>
                                  <th>Procurement Officer Name</th>
                                  <th>No Of Demo to be Established</th>
                                  <th>Product Details </th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredEmployees &&
                                  filteredEmployees.map((itm, i) => {
                                    return (
                                      <tr key={i} className="tablerowview">
                                        <td>{itm.employeeName}</td>
                                        <td className="text-center w-25">
                                          <input
                                            type={"number"}
                                            id={"noOfDemos"}
                                            required
                                            className="form-control"
                                            value={
                                              itm.noOfDemoTobeEstablished || 0
                                            }
                                            onChange={(e) =>
                                              handleDemoChange(
                                                itm.empId,
                                                Number(e.target.value)
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <button
                                            type="button"
                                            className="btn  btn-success mx-2 my-2"
                                            onClick={() => {
                                              setSelectedEmployeeIndex(i);
                                              setModalMode("individual");
                                              setIsOpen(true);
                                            }}
                                          >
                                            Product Details
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>

                          <div className="row text-center">
                            <div className="col-md-12">
                              {" "}
                              <button
                                className="btn  btn-primary mx-2 my-2"
                                type="submit"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </>
                      )}{" "}
                    </>
                  )}
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default AgriPromoterTargetForm;
